import React, { useState } from "react";
import { CheckCircle, SettingsRounded } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";

import { NavigationButton } from "ui";

import analytics from "fond/analytics";
import { Maybe, VersionCoreConfiguration, VersionScenarioConfiguration } from "fond/types";
import { useAppSelector } from "fond/utils/hooks";

import SetupModal from "./SetupModal";

interface SetupPanelProps {
  coreConfiguration: Maybe<VersionCoreConfiguration>;
  scenarioConfiguration: Maybe<VersionScenarioConfiguration>;
  isDisabled: boolean;
}

const SetupPanel: React.FC<SetupPanelProps> = ({ coreConfiguration, scenarioConfiguration, isDisabled }) => {
  const [open, setOpen] = useState(false);
  const versionId = useAppSelector((state) => state.project.versionId);

  const handleOnClick = () => {
    analytics.track("collaboration.cts.setup.opened", {
      versionId,
      isEditing: !!coreConfiguration && !!scenarioConfiguration,
      isReadOnly: isDisabled,
    });
    setOpen(true);
  };

  return (
    <>
      <Typography>Setup the configuration for cost to serve.</Typography>
      <NavigationButton
        title="Setup"
        icon={<SettingsRounded />}
        onClick={handleOnClick}
        rightElement={
          coreConfiguration &&
          scenarioConfiguration && (
            <Box display="flex" alignItems="center">
              <CheckCircle color="success" sx={{ fontSize: 18 }} />
            </Box>
          )
        }
      />

      {open && (
        <SetupModal
          onClose={() => setOpen(false)}
          coreConfiguration={coreConfiguration}
          scenarioConfiguration={scenarioConfiguration}
          isReadOnly={isDisabled}
        />
      )}
    </>
  );
};

export default SetupPanel;
